import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_TAX_SETTINGS: string = '[ecommerce Tax Settings] Load Ecommerce Tax Settings';
export const LOAD_ECOMMERCE_TAX_SETTINGS_SUCCESS: string = '[ecommerce Tax Settings] Load Ecommerce Tax Settings Success';
export const LOAD_ECOMMERCE_TAX_SETTINGS_FAIL: string = '[ecommerce Tax Settings] Load Ecommerce Tax Settings Fail';

export class LoadEcommerceTaxSettings implements Action {
  readonly type: string = LOAD_ECOMMERCE_TAX_SETTINGS;

  constructor(public payload: { websiteId: number }) {
  }
}

export class LoadEcommerceTaxSettingsSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_TAX_SETTINGS_SUCCESS;

  constructor(public payload: {
    data: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommerceTaxSettingsFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_TAX_SETTINGS_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommerceTaxSettingsAction = LoadEcommerceTaxSettings | LoadEcommerceTaxSettingsSuccess | LoadEcommerceTaxSettingsFail;
